// src/utils/sendEmailViaGmail.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

console.log("🔥 sendEmailViaGmail CALLED");
export const sendEmailViaGmail = async ({
  to,
  subject,
  body,
  templateId,
}) => {
  const app = getApp(); // uses your already-initialized Firebase app
  const functions = getFunctions(app);

  const sendEmail = httpsCallable(functions, "sendEmail");

  return await sendEmail({
    to,
    subject,
    body,
    templateId,
  });
};
